import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralize',
})
export class PluralizePipe implements PipeTransform {
  transform(count: number, singular = '', plural = 's'): string {
    return count > 1 ? plural : singular;
  }
}
